/**
 * Created by jane on 17-5-3.
 */

export const QuerySingleKVM = 'kec/QuerySingleKVM';
export const OSImageList = 'kec/OSImageList';
export const QueryEbsPackage = 'kec/QueryEbsPackage';
export const ImageList = 'kec/ImageList';

//宿主机系列
export const QueryDedicatedHostPackage = 'kec/QueryDedicatedHostPackage';
export const DedicateList = 'kec/DedicateList';

export const QueryEipPackage = 'kec/QueryEipPackage';
export const checkBwsConfig = 'kec/checkBwsConfig';
export const bandwidthList = 'kec/bandwidthList';
export const AllVpcInfo = 'kec/AllVpcInfo';
export const AdrList = 'kec/AdrList';
export const DescribePrivateIpAddressAttributes = 'kec/DescribePrivateIpAddressAttributes';
export const AllocatedAdrList = 'kec/AllocatedAdrList';
export const DescribeSubnets = 'kec/DescribeSubnets';
export const DescribeInstancePrivateIpQuota = 'kec/DescribeInstancePrivateIpQuota';
export const AssignPrivateIpAddress = 'kec/AssignPrivateIpAddress';
export const UnAssignPrivateIpAddress = 'kec/UnAssignPrivateIpAddress';
export const OtherCardAssociateAddress = 'kec/OtherCardAssociateAddress';
export const BatchDisassociateAddress = 'kec/BatchDisassociateAddress';
export const QueryQuotaDataByName = 'kec/QueryQuotaDataByName';

export const calcKvmPrice = 'kec/calcKvmPrice';
export const calcEipPrice = 'kec/calcEipPrice';
export const kecAjax = 'kec/kecAjax';
export const judgeGameUser = 'kec/judgeGameUser';
export const getTagKeysList = 'kec/getTagKeysList';
export const describeTagValues = 'kec/describeTagValues';
export const getAvoidPackage = 'kec/getAvoidPackage';
export const getAvoidList = 'kec/getAvoidList';
export const calcAvoidPrice = 'kec/calcAvoidPrice';
export const createProduct = 'kec/createProduct';
export const createAviod = 'kec/createAviod';
export const GetInstanceByIds = 'kec/GetInstanceByIds';
export const DescribeSecurityGroupList = 'kec/DescribeSecurityGroupList';
export const DescribeInstances = 'kec/DescribeInstances';
export const getAllInstance = 'kec/getAllInstance';
export const deleteKec = 'kec/deleteKec';
export const getSnapLimitNum = 'kec/getSnapLimitNum';
export const describeCreateVmType = 'kec/describeCreateVmType';

//试用订单
export const checkTryOrder = 'kec/checkTryOrder';
export const getRenewPrice = 'kec/getRenewPrice';
export const tryOrderRenew = 'kec/tryOrderRenew';
export const tryOrderPositive = 'kec/tryOrderPositive';
export const QueryTryBillType = 'kec/QueryTryBillType';
//商品续费
export const RenewalProduct = 'kec/RenewalProduct';
//开启、关闭、重启
export const StartInstances = 'kec/StartInstances';
export const StopInstances = 'kec/StopInstances';
export const RebootInstances = 'kec/RebootInstances';

//重置密码
export const ModifyInstancePasswd = 'kec/ModifyInstancePasswd';
//制作镜像
export const CreateImage = 'kec/CreateImage';
//从容灾组删除
export const RemoveAvoid = 'kec/RemoveAvoid';
//敏感操作获取
export const timeLimit = 'kec/timeLimit';
//敏感操作设置
export const timeSet = 'kec/timeSet';
//发送验证码
export const sendMsg = 'kec/sendMsg';
//检验验证码
export const checkSms = 'kec/checkSms';

export const validDia = 'kec/validDia';
//升配
export const upgradeKvm  = 'kec/upgradeKvm';
export const checkOp = 'kec/checkOp';
//获取弹性IP列表
export const getEIPList = 'kec/getEIPList';
//绑定Eip 和 解绑Eip
export const bandEip = 'kec/bandEip';
export const unBandEip = 'kec/unBandEip';

//查询通用折扣信息
export const queryCommonDiscount = 'kec/queryCommonDiscount';
//查询用户折扣信息
export const queryDisCount = 'kec/queryDisCount';

//获取ebs信息
export const queryRenewEbsVolumes = 'kec/queryRenewEbsVolumes';

//主机操作
export const updateNetworkConfig = 'kec/updateNetworkConfig';
//添加标签
export const addTags = 'kec/addTags';
//更改业务组
export const getGroupIds = 'kec/getGroupIds';
export const getBasicGroups = 'kec/getBasicGroups';
export const updateGroup = 'kec/updateGroup';
export const createGroup = 'kec/createGroup';
export const updateRelation = 'kec/updateRelation';

//卸载辅网卡
export const unload = 'kec/unload';
export const mount = 'kec/mount';
export const batchMountVifs = 'kec/batchMountVifs';
export const colsChecked = 'kec/colsChecked';

//降配白名单
export const ValidateDowngrade = 'kec/ValidateDowngrade';
//修改主机名称
export const ModifyInstanceName = 'kec/ModifyInstanceName';
//修改网卡名称
export const ModifyNetworkInterface = 'kec/ModifyNetworkInterface';
//旧版防火墙
export const getFirewallList = 'kec/getFirewallList';
export const getFireWallDetail = 'kec/getFireWallDetail';
export const batchEditAttach = 'kec/batchEditAttach';
//重装系统
export const reinstall = 'kec/reinstall';
export const ModifyImageProduct = 'kec/ModifyImageProduct';
//修改DNS名称
export const updateDNSName = 'kec/updateDNSName';

//删除tag
export const deleteTag = 'kec/deleteTag';

export const getProjList = 'kec/getProjList';
export const changeProjTo = 'kec/changeProjTo';
export const DescribeInstancesByTagValue = 'kec/DescribeInstancesByTagValue';

export const SearchInstances = 'kec/SearchInstances';
export const SearchAllInstances = 'kec/SearchAllInstances';

//-预约升配预失败更新状态
export const MigrateUpgradeResetState = 'kec/MigrateUpgradeResetState';
export const RegionInfos = 'kec/RegionInfos';

//-恢复绑定和解绑失败状态
export const RecoveryDetachKeyOrAttachKeyState = 'kec/RecoveryDetachKeyOrAttachKeyState';

//-变更实例类型 排队中 可以取消
export const CancelCrossInstanceMigrate = 'kec/CancelCrossInstanceMigrate';

export const QueryProductGroups = 'kec/QueryProductGroups';
export const Getlines = 'kec/Getlines';

export const instanceMigrate = 'kec/instanceMigrate';

//镜像市场
export const describeMarketTAbList = 'kec/describeMarketTAbList';
export const describeMarketImage = 'kec/describeMarketImage';

export const attachKey = 'kec/apiAttachKey';

//创建升配商品支持批量
export const ModifyInstanceTypeProduct = 'kec/ModifyInstanceTypeProduct';

//修改显示设置 支持批量
export const ModifyInstanceScreenResolution = 'kec/ModifyInstanceScreenResolution';

//实例绑定/修改IAM角色）支持批量
export const AttachInstancesIamRole = 'kec/AttachInstancesIamRole';

//实例解绑IAM角色支持批量
export const DetachInstancesIamRole = 'kec/DetachInstancesIamRole';

//获取kec服务下所有IAM角色列表
export const DescribeKecIamRoles = 'kec/DescribeKecIamRoles';

//主机加入容灾
export const createAvoid = 'kec/createAvoid';

//概览
export const DescribeOverView = 'kec/DescribeOverView';

export const DescribeUpdateInfos = 'kec/DescribeUpdateInfos';

//获取主机可挂载的ebs盘列表
export const DescribeAvailableVolumes = 'kec/DescribeAvailableVolumes';

//获取主机绑定的ebs盘列表
export const DescribeInstanceVolumes = 'kec/DescribeInstanceVolumes';

//主机挂载EBS盘
export const AttachVolume = 'kec/AttachVolume';

//主机卸载EBS盘
export const DetachVolume = 'kec/DetachVolume';

//获取kvm列表
export const queryKvmList = 'kec/queryKvmList';

//创建实例启动模板
export const createModel = 'kec/createModel';

//创建实例启动模板版本
export const CreateVersion = 'kec/CreateVersion';

//修改实例启动模板
export const modifyModel = 'kec/modifyModel';

//创建预留实例券商品
export const createResProduct = 'kec/createResProduct';

//批量迁移
export const batchinstanceMigrate = 'kec/batchinstanceMigrate';

// 定时删除获取服务器时间
export const getTimeddelDate = 'kec/getTimeddelDate';
export const editTimeddelDate = 'kec/editTimeddelDate';

//分配IPV6地址
export const distributeIpv6 = 'kec/distributeIpv6';

//实例详情页需要获取IPV6 白名单效验
export const distributeIpv6Verification = 'kec/distributeIpv6Verification';

//获取支持IPV6的机型ProductTypeId的数据
export const getIpv6SupportProductType = 'kec/getIpv6SupportProductType';

//变更实例类型 白名单效验
export const changeTypeValidWhitelist = 'kec/changeTypeValidWhitelist';

//镜像预热 白名单效验
export const preheatingValidWhitelist = 'kec/preheatingValidWhitelist';

//查询实例动态网卡个数配额
export const QueryInstanceNetworkInterfaceQuota = 'kec/QueryInstanceNetworkInterfaceQuota';

export const QueryNetworkResource = 'kec/QueryNetworkResource';

export const ValidateIpv6Support = 'kec/ValidateIpv6Support';

//查询未绑定状态网卡列表接口
export const DescribeUnbindNetworkInterfaces = 'kec/DescribeUnbindNetworkInterfaces';

//批量绑定动态网卡
export const AttachNetworkInterfaces = 'kec/AttachNetworkInterfaces';

//卸载辅网卡
export const DetachNetworkInterfaces = 'kec/DetachNetworkInterfaces';

export const DescribeCanMigrateType = 'kec/DescribeCanMigrateType';

//--以下为未登录时constants--
export const noLoginCalcEipPrice = 'kec/noLoginCalcEipPrice';
export const noLoginCalcKvmPrice = 'kec/noLoginCalcKvmPrice';
export const noLoginQueryNetworkResource = 'kec/noLoginQueryNetworkResource';
export const noLoginCreateProduct = 'kec/noLoginCreateProduct';
//--以上为未登录时constants--

// 挂载系统盘
export const QueryAttachSystemDiskVolume = 'kec/QueryAttachSystemDiskVolume';
export const AttachSystemDiskVolume = 'kec/AttachSystemDiskVolume';
//预迁移
export const PreMigrateInstance = 'kec/PreMigrateInstance';
export const CancelPreMigrateInstance = 'kec/CancelPreMigrateInstance';
// 定时预迁移
export const ModifyInstanceAutoPreMigrateTime = 'kec/ModifyInstanceAutoPreMigrateTime';
export const CancelInstanceAutoPreMigrateTime = 'kec/CancelInstanceAutoPreMigrateTime';

//获取剩余可开小套餐数量
export const DescribeMinFlavorCount = 'kec/DescribeMinFlavorCount';

//获取项目制最大可查询数量
export const DescribeProjectMaxNum = 'kec/DescribeProjectMaxNum';

//获取实例系统盘信息
export const DescribeInstanceSystemVolume = 'kec/DescribeInstanceSystemVolume';

//获取某个VPC下所有的安全组
export const SecurityGroupVpcInfo = 'kec/SecurityGroupVpcInfo';
//获取可绑定的安全组最大值
export const DescribeSecurityGroupsQuota = 'kec/DescribeSecurityGroupsQuota';
// 设置资源保护开关
export const SetInstanceResourceProtect = 'kec/SetInstanceResourceProtect';

// 获取套餐可挂载弹性网卡数量
export const QueryProductNetworkInterfaceQuota = 'kec/QueryProductNetworkInterfaceQuota';

// 获取ebs盘的吞吐量和IOPS
export const DescribeEbsPerfQuotas = 'kec/DescribeEbsPerfQuotas';

// 查询专属集群信息
export const DescribeDedicatedBlockStorageClusters = 'kec/DescribeDedicatedBlockStorageClusters';


// 查询用户计费类型
export const DescribeVmUserBillType = 'kec/DescribeVmUserBillType';

// 查看待生效的更改计费类型任务
export const DescribeBatchBillTypeChangeTasks = 'kec/DescribeBatchBillTypeChangeTasks';
// 提交转计费类型任务
export const BatchUpgradeInstanceChargeType = 'kec/BatchUpgradeInstanceChargeType';
// 批量请求价格
export const BatchUpgradeCalculateKVMPrice = 'kec/BatchUpgradeCalculateKVMPrice';

// 获取ESSD_PLX系统盘类型的容量范围
export const DescribeSystemDiskSizeRange = 'kec/DescribeSystemDiskSizeRange';

